import { DateTime } from "luxon";

const Footer = () => {
  return (
    <div className="mt-5 text-center text-xs font-light">
      © {DateTime.now().year}, Reesume All Right Reserved
    </div>
  );
};

export default Footer;
